import ArticleLayout from '@/components/feature/ArticleLayout';
import { guideArticle } from '@/mocks/guideArticle';

export default function HipobuySpreadsheetGuide() {
  return <ArticleLayout article={guideArticle} slug="hipobuy-spreadsheet-guide" />;
}